<template>
  <app-layout>
    <v-card class="ma-3 pa-3">
      <!-- Resume -->
      <v-card-title class="pt-0">
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-layout align-center justify-start row fill-height>
              <div>
                <h2>Ventas recurrentes</h2>
              </div>
              <div class="ml-3">
                <v-select
                  class="fit"
                  color="primary"
                  v-model="selectedYear"
                  item-text="text"
                  item-value="value"
                  :items="years"
                ></v-select>
              </div>
              <div class="ml-3">
                <v-select
                  class=""
                  color="primary"
                  v-model="selectedQuarter"
                  item-text="text"
                  item-value="value"
                  :items="quarters"
                ></v-select>
              </div>
            </v-layout>
          </v-flex>
          <v-flex xs12 md8>
            <!-- Action buttons -->
            <v-layout align-center justify-end row fill-height>
              <div v-if="selectedTableItems.length >= 1">
                <v-btn color="error" @click="showBulkDeleteInvoiceModal = true">
                  <v-icon left>mdi-delete</v-icon>
                  {{ $t('ELIMINAR') }}
                </v-btn>
              </div>
              <div>
                <v-btn color="primary" @click="openNewInvoiceForm()">
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t('CREAR VENTA RECURRENTE') }}
                </v-btn>
              </div>
            </v-layout>
            <!-- End action buttons -->
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <open-billing-recursive-invoice-table
          ref="openbillingInvoiceTable"
          :year="selectedYear"
          :quarter="selectedQuarter"
          @on-selected-items="onSelectedItems($event)"
          @on-show-invoice="onShowInvoice($event)"
          @on-delete-invoice="onDeleteInvoice($event)"
          @on-clone-invoice="onCloneInvoice($event)"
        ></open-billing-recursive-invoice-table>
      </v-card-text>
    </v-card>
    <open-billing-invoice-form
      v-if="showInvoiceModalForm"
      :show-modal="showInvoiceModalForm"
      :key="`inv-form-${invoiceFormKey}`"
      :invoice-id="selectedInvoiceId"
      :clone-invoice-id="cloneInvoiceId"
      :recursive="true"
      :disabled="disabledInvoiceForm"
      @click-on-close="closeInvoiceModalForm()"
      @on-saved-invoice="onSavedInvoice()"
      @on-delete-invoice="deleteSingleInvoice($event)"
    ></open-billing-invoice-form>
    <!-- Modal to delete invoices -->
    <v-layout row justify-center>
      <v-dialog v-model="showDeleteInvoiceModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de eliminar la factura seleccionada?
                  </h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeDeleteInvoiceModal()">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmDeleteInvoice()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
    <!-- Modal to delete bulk invoices -->
    <v-layout row justify-center>
      <v-dialog v-model="showBulkDeleteInvoiceModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de eliminar las ventas seleccionadas?
                  </h2>
                  <p>Las facturas que estén contabilizadas por el asesor no serán eliminadas</p>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showBulkDeleteInvoiceModal = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmDeleteBulkInvoices()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
    <v-snackbar v-model="snack" bottom right :timeout="3000" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout';
import apiCtrl from '@/services/api/abstract/abstract-api';
import { recursiveInvoiceType } from '@/modules/openbilling/helpers/invoices';
import OpenBillingRecursiveInvoiceTable from '@/modules/openbilling/components/OpenBillingRecursiveInvoiceTable';
import OpenBillingInvoiceForm from '@/modules/openbilling/components/OpenBillingInvoiceForm';

export default {
  name: 'OpenBillingRecursiveInvoiceList',
  components: {
    AppLayout,
    'open-billing-recursive-invoice-table': OpenBillingRecursiveInvoiceTable,
    'open-billing-invoice-form': OpenBillingInvoiceForm,
  },
  props: [],
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      years: [],
      disabledInvoiceForm: false,
      quarters: [
        {
          text: 'Año completo',
          value: null,
        },
        {
          text: '1er Trimestre',
          value: 1,
        },
        {
          text: '2o Trimestre',
          value: 2,
        },
        {
          text: '3er Trimestre',
          value: 3,
        },
        {
          text: '4o Trimestre',
          value: 4,
        },
      ],
      selectedQuarter: null,
      totalAmountInvoiced: 0,
      totalAmountWithoutPay: 0,
      showInvoiceModalForm: false,
      showDeleteInvoiceModal: false,
      showBulkDeleteInvoiceModal: false,
      invoiceFormKey: 0,
      selectedInvoiceId: null,
      cloneInvoiceId: null,
      selectedTableItems: [],
      invoiceLogo: null,
      snack: false,
      snackText: '',
      snackColor: 'info',
    };
  },
  mounted() {
    this.getYears();
    this.getLogoBase64();
  },
  computed: {
    clavedat() {
      return this.$store.state.clavedat;
    },
    billingProfileId() {
      return this.$store.getters.currentOpenbillingProfileId;
    },
  },
  methods: {
    showSnackMessage(action, message) {
      this.snackColor = action;
      this.snackText = message;
      this.snack = true;
    },
    getBillingInvoices() {
      this.$refs['openbillingInvoiceTable'].getBillingInvoices();
    },
    getLogoBase64() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/settings/logo/${this.billingProfileId}/base64`)
        .then(res => {
          this.invoiceLogo = res.data;
        })
        .catch(() => {});
    },
    getYears() {
      let currentYear = new Date().getFullYear();
      let years = [];
      for (let i = 10; i >= 0; i--) {
        years.push({ text: currentYear - i, value: currentYear - i });
      }
      this.years = years.sort((a, b) => b.value - a.value);
    },
    openNewInvoiceForm() {
      this.showInvoiceModalForm = true;
    },
    closeInvoiceModalForm() {
      this.showInvoiceModalForm = false;
      this.resetInvoiceForm();
    },
    resetInvoiceForm() {
      this.invoiceFormKey++;
      this.selectedInvoiceId = null;
      this.cloneInvoiceId = null;
      this.disabledInvoiceForm = false;
    },
    onSavedInvoice() {
      this.showSnackMessage('success', 'Datos guardados correctamente');
      this.closeInvoiceModalForm();
      this.$refs['openbillingInvoiceTable'].getBillingInvoices();
    },
    onShowInvoice(invoice) {
      this.selectedInvoiceId = invoice.id;
      this.disabledInvoiceForm = true;
      this.showInvoiceModalForm = true;
    },
    onDeleteInvoice(invoice) {
      if (invoice.blocked) {
        this.showSnackMessage('error', 'La factura está bloqueada');
      } else {
        this.selectedInvoiceId = invoice.id;
        this.showDeleteInvoiceModal = true;
      }
    },
    confirmDeleteInvoice() {
      this.deleteSingleInvoice(this.selectedInvoiceId);
      this.showDeleteInvoiceModal = false;
    },
    closeDeleteInvoiceModal() {
      this.showDeleteInvoiceModal = false;
      this.selectedInvoiceId = null;
    },
    deleteSingleInvoice(id) {
      apiCtrl
        .post(`/openbilling/${this.clavedat}/invoices/delete`, { id: id })
        .then(() => {
          this.closeDeleteInvoiceModal();
          this.$refs.openbillingInvoiceTable.getBillingInvoices();
        })
        .catch(err => {
          console.log(err);
          this.closeDeleteInvoiceModal();
        });
    },
    onCloneInvoice(invoice) {
      this.cloneInvoiceId = invoice.id;
      this.showInvoiceModalForm = true;
    },
    onSelectedItems(selectedItems) {
      this.selectedTableItems = selectedItems;
    },
    confirmDeleteBulkInvoices() {
      let ids = [];
      this.selectedTableItems.forEach(item => {
        ids = ids.concat(item['id']);
      });
      this.deleteBulkInvoices(ids);
    },
    deleteBulkInvoices(ids) {
      apiCtrl
        .post(`/openbilling/${this.clavedat}/invoices/bulk-delete`, { ids: ids })
        .then(() => {
          this.showBulkDeleteInvoiceModal = false;
          this.getBillingInvoices();
        })
        .catch(err => {
          console.log(err);
          this.showBulkDeleteInvoiceModal = false;
        });
    },
  },
  watch: {},
};
</script>

<style scoped>
.v-select.fit {
  width: min-content !important;
}
</style>
